import React from 'react';

const CanvasConnections = ({ notes, connections }) => {
  // Simple straight line connections for the spatial canvas
  return (
    <svg className="absolute inset-0 w-full h-full pointer-events-none z-0">
      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
          <polygon points="0 0, 10 3.5, 0 7" fill="#cbd5e1" />
        </marker>
      </defs>
      {connections.map((conn, idx) => {
        const sourceNode = notes.find(n => n.id === conn.source);
        const targetNode = notes.find(n => n.id === conn.target);
        
        if (!sourceNode || !targetNode) return null;

        // Approximate centers of cards (72 w = 288px, padding etc. rough estimate 144px offset)
        const x1 = sourceNode.x + 144;
        const y1 = sourceNode.y + 100;
        const x2 = targetNode.x + 144;
        const y2 = targetNode.y + 100;

        // Simple bezier curve for futuristic look
        const dx = Math.abs(x2 - x1) * 0.5;
        const path = `M ${x1} ${y1} C ${x1 + dx} ${y1}, ${x2 - dx} ${y2}, ${x2} ${y2}`;

        return (
          <path
            key={idx}
            d={path}
            fill="none"
            stroke="#cbd5e1"
            strokeWidth="2"
            strokeDasharray="4 4"
            markerEnd="url(#arrowhead)"
            className="opacity-60"
          />
        );
      })}
    </svg>
  );
};

export default CanvasConnections;